const linksToMobileApps = {
    android:
        'https://play.google.com/store/apps/details?id=cz.primaplatba.primaplatba',
    android_business:
        'https://play.google.com/store/apps/details?id=cz.primaplatba.ppvendorapp',
    ios: 'https://itunes.apple.com/us/app/trisbee/id1239588371',
    ios_app_id: 'HQSVLPRMY5.cz.primaplatba.PPPayment',
    ios_business: 'https://apps.apple.com/cz/app/trisbee-go/id1411327265',
    webapp: 'https://app.trisbee.com',
    tickets: 'https://www.goforboom.com/?utm_source=trisbee.com&utm_medium=web&utm_campaign=products_item&utm_content=ticket%20sale%20interface',
    pay_link_example: 'https://pay.trisbee.com/honza/1',
    prestashop: 'https://github.com/trisbee/prestashop',
};

export {
    linksToMobileApps
}
